// URL pública del login de API; en local la base es relativa (/api), así que se muestra un marcador.
export function apiLoginUrl(
    authBaseUrl: string | undefined = import.meta.env.VITE_API_AUTH_BASE_URL,
): string {
    const base = authBaseUrl?.trim() ?? '';
    return /^https?:\/\//.test(base)
        ? `${base.replace(/\/$/, '')}/auth/api/login`
        : 'https://<dominio-de-la-api>/rbac/auth/api/login';
}

/** Ejemplo de login con curl. El secreto va como variable de entorno para no repetirlo en pantalla. */
export function buildApiLoginCurl(clientId: string, tenantId: string, url = apiLoginUrl()): string {
    return [
        `curl -X POST '${url}' \\`,
        `  -H 'Content-Type: application/json' \\`,
        `  -d '{`,
        `    "clientId": "${clientId}",`,
        `    "tenantId": "${tenantId}",`,
        `    "clientSecret": "'"$CLIENT_SECRET"'"`,
        `  }'`,
    ].join('\n');
}
